// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2cqlO","description":"PatientConsentPreview_description__1thzz"};